/* ============================================================
   Gradient Animated Borders — JS Controller
   ============================================================
   Reads the chosen animation style and applies the correct
   modifier class to all .grad-border elements, plus handles
   auto-targeting from customizer checkboxes.
   ============================================================ */

(function () {
  'use strict';

  var container = document.getElementById('grad-border-config');
  if (!container) return;

  var animation = container.dataset.animation || 'morph';

  // Selectors for auto-targeted elements
  var autoSelectors = [];
  if (container.dataset.buttons === 'true') {
    autoSelectors.push('.btn', '.shopify-payment-button button', 'button[type="submit"]');
  }
  if (container.dataset.cards === 'true') {
    autoSelectors.push('.product-card', '.card', '.collection-card', '[class*="card--"]');
  }
  if (container.dataset.sections === 'true') {
    autoSelectors.push('.shopify-section > .page-width', '.shopify-section > div:first-child');
  }
  if (container.dataset.images === 'true') {
    autoSelectors.push('.product__media img', '.product-card__image', '.image-wrapper');
  }
  if (container.dataset.inputs === 'true') {
    autoSelectors.push('input[type="text"]', 'input[type="email"]', 'input[type="password"]', 'select', 'textarea');
  }

  // Custom selectors
  var customSel = container.dataset.custom || '';
  if (customSel) {
    customSel.split('\n').forEach(function (s) {
      s = s.trim();
      if (s) autoSelectors.push(s);
    });
  }

  // Apply .grad-border and animation class to all targeted elements
  var animClass = 'grad-border--' + animation;

  // Elements with .grad-border class already
  document.querySelectorAll('.grad-border').forEach(function (el) {
    el.classList.add(animClass);
  });

  // Auto-targeted elements
  if (autoSelectors.length > 0) {
    try {
      var combined = autoSelectors.join(', ');
      document.querySelectorAll(combined).forEach(function (el) {
        el.classList.add('grad-border', animClass);
      });
    } catch (e) {
      // Invalid selector — skip gracefully
      console.warn('[Gradient Borders] Invalid selector:', e.message);
    }
  }

  // Respect reduced motion
  var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
  function motionPref(e) {
    document.querySelectorAll('.grad-border').forEach(function (el) {
      if (e.matches) {
        el.style.setProperty('--gb-speed', '0s');
      } else {
        el.style.removeProperty('--gb-speed');
      }
    });
  }
  mq.addEventListener('change', motionPref);
  motionPref(mq);

  /* ── Perf: IntersectionObserver — pause off-screen borders ── */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.classList.toggle('grad-border--paused', !entry.isIntersecting);
      });
    }, { rootMargin: '100px' }); // 100px buffer so animation starts before entering viewport

    document.querySelectorAll('.grad-border').forEach(function (el) {
      io.observe(el);
    });

    // Also observe any dynamically added borders (e.g. swatch labels from custom selectors)
    if ('MutationObserver' in window) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (n) {
            if (n.nodeType === 1) {
              if (n.classList && n.classList.contains('grad-border')) io.observe(n);
              if (n.querySelectorAll) {
                n.querySelectorAll('.grad-border').forEach(function (el) { io.observe(el); });
              }
            }
          });
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  /* ── Perf: pause ALL border animations when tab is hidden ── */
  document.addEventListener('visibilitychange', function () {
    var paused = document.hidden;
    document.querySelectorAll('.grad-border').forEach(function (el) {
      el.classList.toggle('grad-border--paused', paused || false);
    });
  });

})();
